import { isStudySummaryEnabled } from "@/study-summary/settings";

const getInitialState = () => ({
  showPanel: isStudySummaryEnabled()
});

export default {
  namespaced: true,
  state: getInitialState(),
  getters: {
    showPanel: state => state.showPanel
  },
  mutations: {
    reset: state => {
      const initial = getInitialState();
      Object.keys(initial).forEach(key => (state[key] = initial[key]));
    },
    setShowPanel: (state, value) => {
      state.showPanel = isStudySummaryEnabled() ? Boolean(value) : false;
    }
  }
};
